<template>
  <div>
    <LmComponentLoading v-if="isLoading" fixed />
    <div
      v-if="!documentSignedFeedback && !tokenExpiredFeedback"
    >
      <header class="fixed top-0 left-0 w-full shadow-md z-10">
        <div class="navbar-custom d-flex justify-content-between align-items-center p-2 bg-white shadow-md">
          <div>
            <img src="@/assets/images/logo-lumbredocs-black.png" alt="Logo" class="logo-img">
          </div>
          <div class="d-flex gap-4">
            <LmButton
              v-if="canBeRejectedByMe"
              class="mb-0"
              buttonClass="btn-danger"
              value="Rechazar"
              @click="onReject"
              :disabled="!canBeRejectedByMe || isLoading"
              requireConfirmation
            />
            <LmButton
              v-if="canBeReviewedByMe"
              :value="$t('approve')"
              class="mb-0"
              type="button"
              buttonClass="btn-success"
              @click="onReview()"
              :disabled="!canBeReviewedByMe || isLoading"
            />
            <LmButton
              v-if="canBeSignedByMe"
              class="mb-0"
              buttonClass="btn-success"
              value="Firmar"
              @click="onBeforeSign"
              :disabled="!canBeSignedByMe || isLoading"
            />
            <div class="document-signed-alert" v-if="documentWasSignedByMe">
              <i class="mdi mdi-check-circle-outline"></i>
              Documento Firmado
            </div>
          </div>
        </div>
      </header>
      <div class="mt-16" v-if="!isOnEditableStatus && documentData">
        <div class="" v-if="documentData">
          <h1 class="h4 p-2">Nombre del Documento: {{documentData.documentName}}</h1>
          <div class="row w-100 mx-0">
            <LmFileViewer ref="fileviewer" class="col-12" :files="files"/>
          </div>
        </div>
      </div>
      <LmSvgIcon
        v-if="isOnEditableStatus"
        icon="LmEditableIcon"
        wrapperClass="my-4 d-flex align-items-center flex-column"
        text="El documento está siendo revisado por su creador."
        width="15em"
      />
      <div v-if="appUsageTermsRejectedFeedback">
        <LmSvgIcon
          icon="LmTermsIcon"
          wrapperClass="my-4 d-flex align-items-center flex-column"
          text="Debes aceptar los Términos y Condiciones para continuar."
          width="15em"
        />
        <LmButton
          buttonClass="btn-outline-primary"
          class="d-flex justify-content-center"
          value="Ver términos y condiciones"
          @click="validateTyC"
        />
      </div>
      <div v-if="locationMessageFeedback">
        <LmSvgIcon
          icon="LmLocationIcon"
          wrapperClass="my-4 d-flex align-items-center flex-column"
          text="Necesitamos que actives la localización en tu dispositivo para continuar."
          width="15em"
        />
        <LmButton
          buttonClass="btn-outline-primary"
          class="d-flex justify-content-center"
          value="Ya activé la localización, continuemos"
          @click="activateLocation"
        />
      </div>
      <LmFooter />
    </div>

    <div class="full-alert" v-if="(documentWasSignedByMe && documentSignedFeedback) || (documentWasApprovedByMe && documentApprovedFeedback)">
      <div class="close-btn" @click="documentSignedFeedback = false; documentApprovedFeedback = false">
        <i class="mdi mdi-close"></i>
      </div>
      <div class="message w-50 text-center">
        <i class="mdi mdi-check-circle-outline"></i>
        <h3 v-if="documentSignedFeedback">Documento Firmado</h3>
        <h3 v-else-if="documentApprovedFeedback">Documento Aprobado</h3>
        <p>
          ¿Sabías que gestionando tus documentos de forma digital contribuis a reducir la deforestación y ahorrar agua?
        </p>
        <p>
          <b-link href="https://lumbredocs.com.ar" target="_blank" class="lm-link">Obtené mas información</b-link>
        </p>
        <!-- <button
          class="lm-button"
          :disabled="iAmRecipient"
          @click="onAddMeToRecipients"
        >
          <template v-if="!isAcctionProcessing">
            {{ iAmRecipient ? 'Recibirás el documento por mail al finalizarse' : 'Quiero recibir el documento al finalizarse' }}
          </template>
          <template v-else>
            <i class="mdi mdi-loading lm-button-loading"></i>
          </template>
        </button> -->
        <div class="mt-4">
          <img :src="$store.state.settings.logoHomeImg" height="30px" alt="Logo" class="py-2">
        </div>
      </div>
    </div>
    <div class="full-alert danger" v-if="tokenExpiredFeedback">
      <div class="message w-50 text-center">
        <i class="mdi mdi-block-helper"></i>
        <h3>El Enlace Expiró</h3>
        <p>¿Sabías que gestionando tus documentos de forma digital contribuis a reducir la deforestación y ahorrar agua? <b-link href="https://lumbredocs.com.ar" target="_blank" class="lm-link">Obtené mas información</b-link></p>
        <!-- <button
          class="lm-button"
          :disabled="tokenRequested"
          @click="onRequestToken"
        >
          <template v-if="!isAcctionProcessing">
            {{ tokenRequested ? 'Nuevo enlace solicitado' : 'Quiero recibir un nuevo enlace' }}
          </template>
          <template v-else>
            <i class="mdi mdi-loading lm-button-loading"></i>
          </template>
        </button> -->
        <div class="mt-4">
          <img :src="$store.state.settings.logoHomeImg" height="30px" alt="Logo" class="py-2">
        </div>
      </div>
    </div>
    <lmConfirmationModal
      ref="lmConfirmationModalFirmarToken" title="Aviso"
      :message="confirmationModalMsg"
      no-close-on-backdrop
    />
    <LmSendOTP
      ref="lmValidationModalFirmarToken"
      title="Aviso"
      :isTokenForExternal=true
      message="Un código fue enviado a su mail, por favor ingreselo a continuación."
      @ok="setToken"
      no-close-on-backdrop
    />
    <b-modal
      id="tyc-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      scrollable
    >
      <small>Version: {{ appUsageTerms.version }}</small>
      <div v-html="appUsageTerms.termsAndConditions"></div>
      <div v-html="appUsageTerms.privacyPolicies"></div>
      <template #modal-footer>
        <b-button variant="danger" disabled @click="onRejectTyC">Rechazar</b-button>
        <b-button variant="success" disabled @click="onApproveTyC">Aceptar</b-button>
      </template>
    </b-modal>
    <LmBiometricValidation ref="biometric-validation" @ok="onBiometricValidationOk" />
  </div>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmSendOTP from '@/components/modals/LmSendOTP'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmFooter from '@/components/LmFooter'
import LmBiometricValidation from '@/components/LmBiometricValidation'
import LmFileViewer from '@/components/LmFileViewer'
// Vuex
import { mapState, mapMutations } from 'vuex'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmButton,
    LmSendOTP,
    lmConfirmationModal,
    LmFooter,
    LmBiometricValidation,
    LmFileViewer
  },
  data () {
    return {
      isAcctionProcessing: false,
      isLoading: false,
      documentData: null,
      customization: null,
      otpToken: null,
      documentSignedFeedback: false,
      documentApprovedFeedback: false,
      tokenExpiredFeedback: false,
      appUsageTermsRejectedFeedback: false,
      tokenRequested: false,
      locationMessageFeedback: false,
      location: null
    }
  },
  computed: {
    ...mapState('settings', ['appUsageTerms']),
    canBeSignedByMe () {
      return this.documentData?.canBeSignedByMe || false
    },
    canBeRejectedByMe () {
      return this.documentData?.canBeRejectedByMe || false
    },
    canBeReviewedByMe () {
      return this.documentData?.canBeReviewedByMe || false
    },
    lumbreVersion () {
      return this.documentData?.lumbreVersion
    },
    confirmationModalMsg () {
      if (this.canBeSignedByMe) {
        return 'Va a iniciar el proceso de firma electrónica del documento.  ¿Está seguro?'
      }
      if (this.canBeReviewedByMe) {
        return 'Va a iniciar el proceso de revisión electrónica del documento.  ¿Está seguro?'
      }
    },
    documentWasSignedByMe () {
      return this.documentData?.wasSignedByMe || false
    },
    documentWasApprovedByMe () {
      return this.documentData?.wasApprovedByMe || false
    },
    iAmRecipient () {
      return this.documentData?.iAmRecipient || false
    },
    isOnEditableStatus () {
      return this.documentData?.isOnEditableStatus || false
    },
    signatureType () {
      return this.documentData?.signature || null
    },
    files () {
      return [
        {
          name: this.documentData.documentInPdf.name,
          path: this.documentData.documentInPdf.src,
          src: this.documentData.documentInPdf.src
        }
      ]
    }
  },
  methods: {
    ...mapMutations('settings', ['mutateAppUsageTerms']),
    async onReject () {
      this.isLoading = true
      try {
        await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'reject',
          token: this.$route.params.token,
          location: this.location
        })
        this.lmToastSuccessMessage(`Se rechazó ${this.documentData?.documentName || ' el documento'} correctamente.`, 'Documento rechazado.')
        this.documentData.canBeSignedByMe = false
        this.documentData.canBeRejectedByMe = false
        this.documentData.canBeReviewedByMe = false
        this.documentData.isOnEditableStatus = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onReview () {
      try {
        this.isLoading = true
        await this.$refs.lmConfirmationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'generateotp',
          token: this.$route.params.token,
          location: this.location
        })
        this.$refs.lmValidationModalFirmarToken.setIsCommentProps(true, true, 'Codigo', 'token')
        await this.$refs.lmValidationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'review',
          token: this.$route.params.token,
          otp: this.otpToken,
          location: this.location
        })
        this.lmToastSuccessMessage(`Se revisó ${this.documentData?.documentName || ' el documento'} correctamente.`, 'Documento revisado.')
        this.documentData.canBeSignedByMe = false
        this.documentData.canBeRejectedByMe = false
        this.documentData.canBeReviewedByMe = false
        this.documentData.wasApprovedByMe = true
        this.documentApprovedFeedback = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onBiometricValidationOk () {
      try {
        this.isLoading = true
        await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'generateotp',
          token: this.$route.params.token,
          location: this.location
        })
        this.$refs.lmValidationModalFirmarToken.setIsCommentProps(true, true, 'Codigo', 'token')
        await this.$refs.lmValidationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'sign',
          token: this.$route.params.token,
          otp: this.otpToken,
          location: this.location
        })
        this.lmToastSuccessMessage(`Se firmó ${this.form?.documentName || ' el documento'} correctamente.`, 'Documento firmado.')
        this.documentData.canBeSignedByMe = false
        this.documentData.canBeRejectedByMe = false
        this.documentData.wasSignedByMe = true
        this.documentSignedFeedback = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onBeforeSign () {
      this.lmModalInformationMessage({
        modalClosable: false,
        modalKeyboard: false,
        resultSubtitle: '',
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true
          },
          {
            btnText: this.$t('sign'),
            btnCallback: () => {
              this.onSign()
            }
          }
        ],
        message: this.$t('confirmations.start_sign_confirmation')
      })
    },
    async onSign () {
      try {
        this.isLoading = true
        if (this.signatureType === 'electronic') {
          return this.$refs['biometric-validation'].show()
        }
        if (this.signatureType === 'electronic_without_otp') {
          await commonsApi.axiosPostWrapper('/documents/external', {
            request: 'sign',
            token: this.$route.params.token,
            otp: this.otpToken,
            location: this.location
          })
          this.lmToastSuccessMessage(`Se firmó ${this.form?.documentName || ' el documento'} correctamente.`, 'Documento firmado.')
          this.documentData.canBeSignedByMe = false
          this.documentData.canBeRejectedByMe = false
          this.documentData.wasSignedByMe = true
          this.documentSignedFeedback = true
        }
      } catch (error) {
        console.log(error)
        this.lmToastDangerMessage(error.response.data.message, 'Error al firmar')
      } finally {
        this.isLoading = false
      }
    },
    setToken (data) {
      this.otpToken = data.comment
    },
    async onAddMeToRecipients () {
      try {
        this.isAcctionProcessing = true
        await commonsApi.axiosPostWrapper('/documents/add-external-to-recipients', {
          token: this.$route.params.token,
          location: this.location
        })
        this.documentData.iAmRecipient = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isAcctionProcessing = false
      }
    },
    async onRequestToken () {
      try {
        this.isAcctionProcessing = true
        await commonsApi.axiosPostWrapper('/documents/external-request-token', {
          id: this.$route.params.id,
          location: this.location
        })
        this.tokenRequested = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isAcctionProcessing = false
      }
    },
    async validateTyC () {
      if (process.env?.VUE_APP_ENABLE_TYC !== 'yes') {
        return true
      }
      try {
        const response = await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'validatetyc',
          token: this.$route.params.token,
          location: this.location
        })
        this.mutateAppUsageTerms(response.data.doc)
        this.$bvModal.show('tyc-modal')
        this.$nextTick(() => {
          const modal = document.querySelector('#tyc-modal .modal-body')
          if (modal) {
            modal.addEventListener('scroll', () => {
              const documentHeight = modal.scrollHeight - modal.offsetHeight - 1
              const currentScroll = modal.scrollTop
              const modifier = 80
              if (currentScroll + modifier > documentHeight) {
                const buttons = document.querySelectorAll('#tyc-modal .modal-footer button')
                for (const node of buttons) {
                  node.disabled = false
                  node.classList.remove('disabled')
                }
              }
            })
          }
        })
        return false
      } catch (error) {
        console.log(error)
        if (error.response.data.message.name === 'TokenExpiredError') {
          this.tokenExpiredFeedback = true
        }
        return false
      }
    },
    async onApproveTyC () {
      try {
        await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'approvetyc',
          tyc: this.appUsageTerms._id,
          token: this.$route.params.token,
          location: this.location
        })
        this.$bvModal.hide('tyc-modal')
        await this.loadDocument()
        this.appUsageTermsRejectedFeedback = false
      } catch (error) {
        // TODO. Que pasaria aca?
        console.log(error)
      }
    },
    async onRejectTyC () {
      // TODO. Que pasaria aca?
      console.log('Rechazaste los terminos y condiciones.')
      this.appUsageTermsRejectedFeedback = true
      this.$bvModal.hide('tyc-modal')
    },
    async loadDocument () {
      try {
        this.isLoading = true
        const res = await commonsApi.axiosPostWrapper('/documents/external', {
          request: 'get',
          token: this.$route.params.token,
          location: this.location
        })
        this.documentData = res.data.documentData
        this.customization = res.data.customization
        if (this.documentWasSignedByMe) {
          this.documentSignedFeedback = true
        } else if (this.documentWasApprovedByMe) {
          this.documentApprovedFeedback = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async activateLocation () {
      await this.init()
    },
    getLocation () {
      return new Promise((resolve, reject) => {
        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }

        navigator.geolocation.getCurrentPosition(
          (position) => resolve({
            timestamp: position.timestamp,
            accuracy: position.coords.accuracy,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }),
          // (error) => reject(error),
          (error) => {
            console.log(error)
            resolve()
          },
          options
        )
      })
    },
    async init () {
      try {
        this.isLoading = true
        this.location = await this.getLocation()
        const result = await this.validateTyC()
        if (result) {
          await this.loadDocument()
        } else {
          this.appUsageTermsRejectedFeedback = true
        }
      } catch (error) {
        if (error.code === 1) {
          this.locationMessageFeedback = true
        }
        if (error?.response?.data?.message?.name === 'TokenExpiredError') {
          this.tokenExpiredFeedback = true
        }
      } finally {
        this.isLoading = false
      }
    }
  },
  async created () {
    await this.init()
  }
}
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.logo-img {
  max-width: 200px;
  max-height: 50px;
}

.document-signed-alert {
  color: white;
  background: rgb(1,210,68);
  background: linear-gradient(90deg, rgba(1,210,68,1) 0%, rgba(0,210,197,1) 100%);
  border-radius: 7px;
  padding: 0.4rem 1rem;
}

.document-signed-alert > i {
  font-size: 1rem;
}

.full-alert {
  color: white;
  background: rgb(1,210,68);
  background: linear-gradient(90deg, rgba(1,210,68,1) 0%, rgba(0,210,197,1) 100%);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.full-alert.danger {
  background: rgb(210,60,1);
  background: linear-gradient(90deg, rgba(210,60,1,1) 0%, rgba(210,0,96,1) 100%);
}

.full-alert .lm-link {
  display: inline;
  background: transparent;
  color: white;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}

.full-alert .lm-button {
  min-width: 200px;
  text-transform: uppercase;
  background-color: white;
  color: black;
  border-radius: 20px;
  border: none;
  padding: 8px 20px;
  font-weight: bold;
  transition: all 0.4s ease-in-out;
}

.full-alert .lm-button:disabled {
  cursor: not-allowed;
  background-color: rgba(232, 232, 232, 0.9);
}

.full-alert .lm-button:disabled:hover {
  transform: scale(1);
  box-shadow: none;
}

.full-alert .lm-button:hover {
  transform: scale(1.02);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.full-alert .lm-button .lm-button-loading::before {
  font-weight: bold;
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.full-alert .message > p {
  font-size: 1rem;
}

.full-alert .message > i {
  font-size: 4.4rem;
}

.full-alert .close-btn {
  font-size: 2rem;
  cursor: pointer;
  position: fixed;
  top: 30px;
  right: 30px;
  transition: ease-in-out 0.4s all;
}

.full-alert .close-btn:hover {
  transform: scale(1.2);
}
</style>
